<template>
    <div>
        <v-row>
            <v-divider class="my-2"></v-divider>
            <div class="pa-1">Materiais entregues</div>
        </v-row>
        <v-row>
            <v-col>
                <v-table>
                    <thead>
                        <tr>
                            <th class="text-left">Cód Lupi</th>
                            <th class="text-left">Material</th>
                            <th class="text-left">Entregues</th>
                            <th class="text-left">Total</th>
                            <th class="text-left">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in listaMateriais" :key="item.id">
                            <td>{{ item.codigo_item_lupi }}</td>
                            <td>{{ item.descricao_item_lupi }}</td>
                            <td>{{ item.quantidade_entregue }} / {{ item.quantidade_entregar }}</td>
                            <td>
                                <v-select class="my-1" hide-details
                                    v-show="item.quantidade_entregar - item.quantidade_entregue > 0"
                                    v-model="item.recebendo"
                                    placeholder="Entregar..."
                                    @update:modelValue="entregarParcial($event, item)"
                                    :items="create_range(item.quantidade_entregar, item.quantidade_entregue)">
                                    <template v-slot:append>
                                    </template>
                                </v-select>
    
                            </td>
                            <td>
                                <v-menu top left v-if="itemMenuOptions(item).length"
                                    rounded="bl-xl tl-xl tr-sm br-sm" offset-y
                                    transition="slide-x-transition">
                                    <template v-slot:activator="{ props: activatorProps }">
                                        <v-chip color="primary" 
                                            v-bind="activatorProps" class="pr-1"
                                            v-if="itemMenuOptions(item).length">
                                            <span v-if="$vuetify.display.mdAndUp">
                                                Opções
                                            </span>
                                            <v-divider vertical class="ml-1"></v-divider>
                                            <v-icon>mdi-menu-down</v-icon>
                                            <loading-gdb :propObject="$store.state.checklistdb.loading_id === `delete-material-lupi-${item.id}`" text="Processando Circulação..."
                                            ></loading-gdb>
                                        </v-chip>
                                    </template>
                                    <v-list density="compact">
                                        <v-list-item v-for="m, mi in itemMenuOptions(item)" :key="mi"
                                            @click="m.do()" >
                                            <v-list-item-title>
                                                <v-icon-small color="grey">{{m.icon}}</v-icon-small>
                                                {{m.label}}
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                    <!-- <loading-gdb :propObject="StateRecursosLoading == `get-log-circulacao-${item.id}`"
                                        text="Carregando Logs de Circulação"/> -->
                                </v-menu>
                            </td>
                        </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>

        <helper-gdb text="TabelaMateriaisEntregues" v-if="$store.getters.StateAuthenticatedUser.is_superuser"/>
    </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex'
import ComboBoxPesquisaLupi from './ComboBoxPesquisaLupi.vue';
import HeaderEntregaLupi from './HeaderEntregaLupi.vue';
import CardRegistroEntrega from './CardRegistroEntrega.vue';

export default {
    components: {
        ComboBoxPesquisaLupi,
        HeaderEntregaLupi,
        CardRegistroEntrega
    },
    props: {
        listaMateriais: {
            required: true,
            default: () => []
        },
    },
    methods: {
        create_range(a_entregar, entregue){
            let length = a_entregar - entregue
            // retorna uma lista com valores a partir de 1
            return Array.from({ length: length  }, (_, index) => index +1);
        },
        async entregarParcial(entregando, objeto){
            this.$emit('on-entregar-parcial', { entregando, objeto })
        },
        async devolverParcialMaterial(objeto){
            this.$emit('on-devolver-parcial', { objeto })
        },
        async cancelarEntregaMaterial(objeto){
            this.$emit('on-cancelar-entrega', { objeto })
        },
        itemMenuOptions(item){
            const menus = [
                { 
                    if: true, //['ABERTO'].includes(item.situacao) && this.$verify.has_perm('change_circulacao', false),
                    do: () => this.cancelarEntregaMaterial(item),
                    icon: 'mdi-close',
                    label: 'Cancelar Entrega'
                },
                { 
                    if: item.quantidade_entregue > 0, //['ABERTO'].includes(item.situacao) && this.$verify.has_perm('change_circulacao', false),
                    do: () => this.devolverParcialMaterial(item),
                    icon: 'mdi-refresh',
                    label: 'Devolução'
                },
            ]
            return menus.filter(f=> f.if)
        },
    },
    computed: {
        ...mapGetters([]),
        
    },
    
}
</script>